import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  container: {
    // @ts-ignore
    position: 'fixed',
    left: 0,
    right: 0,
    bottom: 0,
    top: 0,
  },
});
